// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';
import DatePicker from 'vue2-datepicker';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { numberFormatMixins } from '@/app/mixins/modules/number-format-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { errorFocusMixins } from "@/app/mixins/utils/error-focus-mixins";
import { mobileNumberMixins } from "@/app/mixins/utils/mobile-number-mixins";

// Services
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Component

export default {
	name: 'BreederUpdatePuppyPaymentContainer',
	components: {
		DatePicker
	},
	mixins: [
		toastMessageMixins,
		numberFormatMixins,
		inputTextMixins,
		dateMixins,
		errorFocusMixins,
		mobileNumberMixins
	],
	data() {
		return {
			// Loaders
			isAPILoading: false,
			isSubmit: false,

			// Form fields
			soldDate: '',
			company: '',
			contact: '',
			client: '',
			sku: '',
			depositDate: '',
			deposit: '',
			balanceDueDate: '',
			balance: '',
			puppyPrice:'',
			isDepositGreaterThanPrice: false,
			puppyPurchasedId:'',
			puppySellId:'',
			puppyPaymentDetails: {
				soldDate: '',
				company: '',
				contact: '',
				client: '',
				sku: '',
				depositDate: '',
				deposit: '',
				balanceDueDate: '',
				balance: '',
				mobileNumber:'',
				isConfirmedPayment: false
			},
		}
	},
	computed: {
		computedValue() {
			this.isDepositGreaterThanPrice = false

			if (this.puppyPaymentDetails.isConfirmedPayment) {
				return this.balance = 0;
			}

			if(this.deposit) {
				this.isDepositGreaterThanPrice = parseFloat(this.puppyPrice) < parseFloat(this.deposit)
				this.balance = this.puppyPrice - this.deposit
				return this.balance
			} else {
				this.balance = this.puppyPrice
				return this.balance
			}
		},
		validationRules() {
			let fields = {
				depositDate: {},
				deposit: {},
				balanceDueDate: {},
			};
			fields = vuelidateUtil.setRequiredValidation(fields, 'depositDate');
			fields = vuelidateUtil.setRequiredValidation(fields, 'deposit');
			fields = vuelidateUtil.setRequiredValidation(fields, 'balanceDueDate');

			return fields;
		},
		compareFields() {
			const compareDepositDate = this.puppyPaymentDetails.depositDate !== this.depositDate;
			const compareDeposit = this.puppyPaymentDetails.deposit !== this.deposit;
			const compareBalanceDueDate = this.puppyPaymentDetails.balanceDueDate !== this.balanceDueDate;

			return !(compareDepositDate || compareDeposit || compareBalanceDueDate )
		}
	},
	created() {
		if (this.$route.params.id) {
			this.getPuppyPaymentDetails();
		}
	},
	methods: {
		goBackToPuppiesPayment() {
			this.$router.push("/pet-purchases/puppy-payment");
		},
		getPuppyPaymentDetails(){
			puppySellService.getPuppyPaymentDetails(this.$route.params.id)
			.then(res => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.puppyPaymentDetails = res.data;
					this.setModelToUpdate(res.data);
				} else {
					this.showAPIErrorToast('Unable to get breed details.', res);
				}
			})
			.catch(() => {
				this.showGenericErrorToast();
			})
			.finally(() => {
				this.isAPILoading = false;
				this.$v.$touch();
			});
		},
		async onSubmit (isConfirmed = false) {
			this.$v.$touch();
			this.isSubmit = true
			
			if (this.isDepositGreaterThanPrice) {
				this.setFocusOnFirstErrorField()
				return;
			}

			const purchaseDetails = {
				depositDate: this.convertDateToUTC(this.depositDate),
				deposit: this.deposit,
				balanceDueDate: this.convertDateToUTC(this.balanceDueDate),
				balance: isConfirmed ? 0 : this.balance,
				puppySellPurchaseId: this.puppyPurchasedId ? this.puppyPurchasedId:0,
				puppyPrice: this.puppyPrice,
				isConfirmedPuppyPayments: isConfirmed
				
			}
		
			puppySellService.putPuppyPurchaseBalance(this.puppySellId, purchaseDetails)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(`Puppy payment successfully updated!`);
						isConfirmed 
							? this.getPuppyPaymentDetails() 
							: this.$router.push('/pet-purchases/puppy-payment');
					} else {
						this.showAPIErrorToast(`Unable to update payment details.`, res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.isAPILoading = false;
				});
		},
		async onConfirmPayment() {
			this.$swal({
                imageHeight: '150px',
				title: 'Are you sure you want to confirm payment?',
                text: 'Once confirmed, balance to breeder will be updated.',
                imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
                confirmButtonColor: '#4B8BFF',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })
                .then(result => {
                    if (result.value) {
                       this.onSubmit(true)
                    } else {
                        next(false);
                    }
                });
		},
		setModelToUpdate(data) {
			this.soldDate = this.formatDate(data.soldDate);
			this.company = data.companyName;
			this.contact = data.breederName;
			this.client = data.client;
			this.sku = data.puppyReferenceNumber;
			this.depositDate = data.depositDate ? new Date(data.depositDate) : null;
			this.deposit = data.depositAmount;
			this.balanceDueDate = data.balanceDueDate ? new Date(data.balanceDueDate)  : null;
			this.balance = data.balance;
			this.puppyPrice = data.price;
			this.puppyPurchasedId = data.puppySellPurchaseId;
			this.puppySellId = this.$route.params.id;

			this.puppyPaymentDetails = {
				soldDate: this.soldDate,
				company: this.company,
				contact: this.contact,
				client: this.client,
				sku: this.sku,
				depositDate: this.depositDate,
				deposit: this.deposit,
				balanceDueDate: this.balanceDueDate,
				balance: this.balance,
				mobileNumber: data.mobileNumber,
				isConfirmedPayment: data.isConfirmedPayment
			}
		},
		notPastDate(date) {
			if (this.depositDate){
				return date <= new Date(this.depositDate).setHours(0,0,0,0);
			}
				
		},
		notPastDepositDate(date) {
			if (this.balanceDueDate){
				return date >= new Date(this.balanceDueDate).setHours(0,0,0,0);
			}
				
		},
		setBalanceDueDate(date) {
			if (this.depositDate) {
				// Set the default date for the second datepicker based on the selected date
				// For example, you might want to set the endDate to be 7 days after the startDate
				const defaultDate = new Date(this.depositDate);
				defaultDate.setDate(defaultDate.getDate() + 1); // Add 7 days
		
				this.balanceDueDate = defaultDate;
			}
		},
		setDepositDate(date) {
			if (this.balanceDueDate) {
				// Set the default date for the second datepicker based on the selected date
				// For example, you might want to set the endDate to be 7 days after the startDate
				const defaultDate = new Date(this.balanceDueDate);
				defaultDate.setDate(defaultDate.getDate() - 1); // Add 7 days
		
				this.depositDate = defaultDate;
			}
		},
		allowOnlyNumbers(e) {
			const invalidChars = ["-", "+", "e", "E"]
			if (invalidChars.includes(e.key)) {
				e.preventDefault()
			}
		}
	},
	validations() {
		return this.validationRules;
	}
}